import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';

const TABLE_HEADER = [
    {
        header: 'Tray Name',
        accessor: (row) => row?.tray_name
    }
];

export const AddTrayDetailsForm = ({ onClose, onAdd }) => {
    const [medicine, setMedicine] = useState([])
    const [input, setInput] = useState('');
    const [id, setId] = useState('')

    const getMedicineDropdown = useCallback(async () => {
        const data = await dropdownFetch('tray');
        setMedicine(data);
    }, []);

    useEffect(() => {
        getMedicineDropdown();
    }, [getMedicineDropdown]);

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                tray_name: Yup.string().required('Please select Medicine'),
            })
        ),
        defaultValues: {
            quantity: 1
        },
        mode: 'all'
    });
    const { reset } = methods

    const { handleSubmit, setValue, watch } = methods;


    const handleServiceSelection = (row) => {
        console.log("HELLLO ROW MEDICINE", row);
        setValue('tray_name', row?.tray_name);
        setValue('quantity', row?.quantity);
        setId(row._id);
    };

    const formSubmitHandler = (formValues) => {
        console.log("HELLO FORMVALUES BEFORE MERGE:", formValues);
        const updatedFormValues = {
            ...formValues,
            tray_name: formValues.tray_name || "",
            quantity: formValues.quantity || 0,
            id,
        };
        onAdd(updatedFormValues);
    };


    return (
        <Stack spacing={1} sx={{ height: '100%' }}>
            <Stack
                padding={1.5}
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor="grey.300"
            >
                <Typography variant="h4" fontWeight="bold">
                    Add Tray Details
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon color="error" fontSize="large" />
                </IconButton>
            </Stack>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                <MuiTextField
                    sx={{ width: '100%', padding: 0, font: "32px" }}
                    label="Search Tray"
                    variant="outlined"
                    value={input}
                    InputProps={{
                        style: {
                            fontSize: '12px',
                            fontWeight: 600
                        },
                    }}
                />
            </Stack>
            <FormProvider
                sx={{ height: '100%', overflow: 'auto' }}
                methods={methods}
                onSubmit={handleSubmit(formSubmitHandler)}
            >
                <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
                    <Grid
                        item
                        xs={6}
                        sx={{
                            height: '100%',
                            overflow: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1
                        }}
                    >
                        <Table
                            containerSX={{ flex: 1, height: '100%', overflow: 'auto', }}
                            size="small"
                            sx={{ fontSize: "32px" }}
                            data={medicine || []}
                            columns={TABLE_HEADER}
                            onRowClick={handleServiceSelection}

                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: .2, px: 2 }}>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Tray Name</Typography>
                                <TextField
                                    sx={{ flex: 0.8 }}
                                    name="tray_name"
                                    placeholder="Tray Name"
                                />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.45, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                                <TextField
                                    sx={{ flex: 0.8 }}
                                    type="number"
                                    name="quantity"
                                    placeholder="Quantity"
                                />
                            </Stack>
                            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="40%">
                                <Button variant="contained" type="submit"   >
                                    Add
                                </Button>
                                <Button variant="outlined" onClick={onClose} color="error">
                                    Close
                                </Button>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </FormProvider>
        </Stack>
    );
};
